module.exports = __webpack_public_path__ + "img/main.507f9634.webp";